/* eslint-disable @typescript-eslint/prefer-for-of */
import { EventEmitter, useMount } from '@apia/util';
import { useRef } from 'react';
import { shallowEqual } from 'react-redux';

export type TSwitchRoute = {
  /**
   * El callback será llamado si la ruta coincide.
   */
  callback: (result: RegExpMatchArray) => unknown;
  route: RegExp;
};

export type TUseSwitch = TSwitchRoute[];

export class Router extends EventEmitter<{ newRoute: string }> {
  #matchLocation = (regexp: RegExp) => {
    const path =
      '/' +
      (window.location.href
        .replaceAll('%20', ' ')
        .match(new RegExp(`${window.CONTEXT}/?([^?]+)?(?:\\?.*)?`))?.[1] ?? '');

    return path.match(regexp);
  };

  constructor() {
    super();

    window.addEventListener('popstate', () => {
      this.emit('newRoute', window.location.href);
    });
  }

  #evalRoutes = (routes: TUseSwitch) => {
    for (let i = 0; i < routes.length; i++) {
      const match = this.#matchLocation(routes[i].route);
      if (match) {
        return { route: routes[i], match };
      }
    }
  };

  /**
   * Se evaluarán las rutas en orden y la primera en coincidir será tomada como
   * resultado del cambio de ruta.
   *
   * Las rutas provistas deberán matchear contra el path actual. El path actual
   * es la porción de la ruta luego del dominio y el contexto. Ejemplo:
   *
   * http://localhost/apia                              =>      path='/'
   * http://localhost/apia/spa/categories/comidas/1     =>      path='/spa/categories/comidas/1'
   */
  useSwitch = (routes: TUseSwitch) => {
    const lastMatch = useRef<TSwitchRoute | null>(null);

    useMount(() => {
      const result = this.#evalRoutes(routes);
      if (result) {
        result.route.callback(result.match);
      }

      return this.on('newRoute', () => {
        const result = this.#evalRoutes(routes);
        if (result && !shallowEqual(result.match, lastMatch.current)) {
          result.route.callback(result.match);
        }
      });
    });
  };
}
